module.exports = __webpack_public_path__ + "static/media/background_sky.df7360a5.svg";